import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ValidationContext = React.createContext();

export const ValidationControl = (props) => {
    return(
        <ValidationContext.Consumer>
            {
                (validationContext)=> props.children(validationContext)
            }
        </ValidationContext.Consumer>
    );
}

export const ValidationConsumer = (props) => {
    return(
        <ValidationContext.Consumer>
            {
                (validationContext)=> props.children(validationContext.data)
            }
        </ValidationContext.Consumer>
    );
}

export const withValidationConsumer = (Component) => {
    return class extends React.Component {
        render() {
            return(
                <ValidationContext.Consumer>
                    {
                        (validationContext) =>{
                            const {errMsg, isValid} = validationContext.data;
                            return(
                                <Component
                                    {...this.props}
                                    validationErrMsg={errMsg}
                                    isValid={isValid}
                                />
                            )
                        }
                    }
                </ValidationContext.Consumer>
            )
        }
    }
}

export class ValidationProvider extends React.Component {

    state = {
        errMsg: null,
        isValid: true
    }

    updateValidation = (newState) => {
        this.setState(newState);
    }

    render(){
        const context = {
            data: this.state,
            control: {
                updateValidation: this.updateValidation
            }
        }
        return (
                <ValidationContext.Provider value={context}>
                    {this.props.children}
                </ValidationContext.Provider>
        )
    }
}
